import { defineAsyncComponent } from "vue";

type ViewComponent = ReturnType<typeof defineAsyncComponent>;

// login
export const viewLogin: ViewComponent = () => import("@/views/login/index.vue");

// error
export const viewError: ViewComponent = () => import("@/views/error/index.vue");
export const viewSoon: ViewComponent = () => import("@/views/soon/index.vue");

// dashboard component
export const viewDashboard: ViewComponent = () =>
  import("@/views/dashboard/index.vue");

// customer
export const viewCustomer: ViewComponent = () =>
  import("@/views/customer/index.vue");
export const detailCustomer: ViewComponent = () =>
  import("@/views/customer/detail/index.vue");

// branch store
export const viewBranchStore: ViewComponent = () =>
  import("@/views/branch-store/list/index.vue");
export const createBranchStore: ViewComponent = () =>
  import("@/views/branch-store/create/index.vue");
export const updateBranchStore: ViewComponent = () =>
  import("@/views/branch-store/update/index.vue");
export const detailBranchStore: ViewComponent = () =>
  import("@/views/branch-store/detail/index.vue");

// product
export const viewProduct: ViewComponent = () =>
  import("@/views/product/index.vue");
export const createProduct: ViewComponent = () =>
  import("@/views/product/product/create/index.vue");
export const updateProduct: ViewComponent = () =>
  import("@/views/product/product/update/index.vue");
export const detailProduct: ViewComponent = () =>
  import("@/views/product/product/detail/index.vue");

// configuration
export const viewConfiguration: ViewComponent = () =>
  import("@/views/configuration/index.vue");

// uom
export const createUoM: ViewComponent = () =>
  import("@/views/configuration/uom/create/index.vue");
export const updateUoM: ViewComponent = () =>
  import("@/views/configuration/uom/update/index.vue");
export const detailUoM: ViewComponent = () =>
  import("@/views/configuration/uom/update/index.vue");

// brand
export const createBrand: ViewComponent = () =>
  import("@/views/configuration/brand/create/index.vue");
export const updateBrand: ViewComponent = () =>
  import("@/views/configuration/brand/update/index.vue");
export const detailBrand: ViewComponent = () =>
  import("@/views/configuration/brand/update/index.vue");

// category
export const createCategory: ViewComponent = () =>
  import("@/views/configuration/category/create/index.vue");
export const updateCategory: ViewComponent = () =>
  import("@/views/configuration/category/update/index.vue");
export const detailCategory: ViewComponent = () =>
  import("@/views/configuration/category/update/index.vue");

// option
export const createOption: ViewComponent = () =>
  import("@/views/configuration/option/create/index.vue");
export const updateOption: ViewComponent = () =>
  import("@/views/configuration/option/update/index.vue");
export const detailOption: ViewComponent = () =>
  import("@/views/configuration/option/update/index.vue");

// Shipping Fee
export const createShippingFee: ViewComponent = () =>
  import("@/views/configuration/shipping-fee/create/index.vue");
export const updateShippingFee: ViewComponent = () =>
  import("@/views/configuration/shipping-fee/update/index.vue");
export const detailShippingFee: ViewComponent = () =>
  import("@/views/configuration/shipping-fee/update/index.vue");

// Customer Group
export const createCustomerGroup: ViewComponent = () =>
  import("@/views/configuration/customer-group/create/index.vue");
export const updateCustomerGroup: ViewComponent = () =>
  import("@/views/configuration/customer-group/update/index.vue");
export const detailCustomerGroup: ViewComponent = () =>
  import("@/views/configuration/customer-group/update/index.vue");

// Membership
export const createMembership: ViewComponent = () =>
  import("@/views/configuration/membership/create/index.vue");
export const updateMembership: ViewComponent = () =>
  import("@/views/configuration/membership/update/index.vue");
export const detailMembership: ViewComponent = () =>
  import("@/views/configuration/membership/update/index.vue");

// review-rating
export const viewReviewRating: ViewComponent = () =>
  import("@/views/review-rating/index.vue");
export const updateReviewRating: ViewComponent = () =>
  import("@/views/review-rating/review-rating/update/index.vue");
export const detailReviewRating: ViewComponent = () =>
  import("@/views/review-rating/review-rating/update/index.vue");

// promotion
export const viewPromotion: ViewComponent = () =>
  import("@/views/promotion/list/index.vue");
export const createPromotion: ViewComponent = () =>
  import("@/views/promotion/create/index.vue");
export const updatePromotion: ViewComponent = () =>
  import("@/views/promotion/update/index.vue");
export const detailPromotion: ViewComponent = () =>
  import("@/views/promotion/detail/index.vue");

// Advertisement
export const viewAdvertisement: ViewComponent = () =>
  import("@/views/advertisement/index.vue");
export const createAdvertisement: ViewComponent = () =>
  import("@/views/advertisement/advertisement/create/index.vue");
export const updateAdvertisement: ViewComponent = () =>
  import("@/views/advertisement/advertisement/update/index.vue");
export const detailAdvertisement: ViewComponent = () =>
  import("@/views/advertisement/advertisement/detail/index.vue");

// Push to Telegram
export const createPushTelegram: ViewComponent = () =>
  import("@/views/advertisement/push-telegram/create/index.vue");
export const detailPushTelegram: ViewComponent = () =>
  import("@/views/advertisement/push-telegram/detail/index.vue");

// stock
export const viewStock: ViewComponent = () => import("@/views/stock/index.vue");
export const detailStock: ViewComponent = () =>
  import("@/views/stock/stock/detail/index.vue");
export const createStockIn: ViewComponent = () =>
  import("@/views/stock/stock/stock-in/index.vue");
export const createStockOut: ViewComponent = () =>
  import("@/views/stock/stock/stock-out/index.vue");
import("@/views/stock/stock/stock-in/index.vue");
export const createStockAdjustment: ViewComponent = () =>
  import("@/views/stock/stock/stock-adjustment/index.vue");
export const createStockTransfer: ViewComponent = () =>
  import("@/views/stock/stock/stock-transfer/index.vue");
export const updateStockReconcile: ViewComponent = () =>
  import("@/views/stock/stock/stock-reconcile/index.vue");
export const viewStockTransactionHistory: ViewComponent = () =>
  import("@/views/stock/transaction-history/index.vue");
export const viewStockTransferHistory: ViewComponent = () =>
  import("@/views/stock/transfer-history/index.vue");
export const viewStockReconcileHistory: ViewComponent = () =>
  import("@/views/stock/reconcile-history/index.vue");

// sale order
export const viewSaleOrder: ViewComponent = () =>
  import("@/views/sale-order/index.vue");
export const detailSaleOrder: ViewComponent = () =>
  import("@/views/sale-order/sale-order/detail/index.vue");
export const updateSaleOrderStatus: ViewComponent = () =>
  import("@/views/sale-order/sale-order/detail/index.vue");
export const createPaymentMethod: ViewComponent = () =>
  import("@/views/sale-order/payment-method/create/index.vue");
export const updatePaymentMethod: ViewComponent = () =>
  import("@/views/sale-order/payment-method/update/index.vue");
export const detailPaymentMethod: ViewComponent = () =>
  import("@/views/sale-order/payment-method/detail/index.vue");

// notification
export const viewNotification: ViewComponent = () =>
  import("@/views/notification/list/index.vue");
export const createNotification: ViewComponent = () =>
  import("@/views/notification/create/index.vue");
export const updateNotification: ViewComponent = () =>
  import("@/views/notification/update/index.vue");
export const detailNotification: ViewComponent = () =>
  import("@/views/notification/detail/index.vue");

// setting
export const viewSetting: ViewComponent = () =>
  import("@/views/setting/index.vue");
export const createUserAccount: ViewComponent = () =>
  import("@/views/setting/user-account/create/index.vue");
export const updateUserAccount: ViewComponent = () =>
  import("@/views/setting/user-account/update/index.vue");
export const detailUserAccount: ViewComponent = () =>
  import("@/views/setting/user-account/detail/index.vue");

export const createRole: ViewComponent = () =>
  import("@/views/setting/role/create/index.vue");
export const updateRole: ViewComponent = () =>
  import("@/views/setting/role/update/index.vue");
export const detailRole: ViewComponent = () =>
  import("@/views/setting/role/update/index.vue");

export const viewLanguage: ViewComponent = () =>
  import("@/views/setting/language/index.vue");

// warehouse
export const viewWarehouse: ViewComponent = () =>
  import("@/views/warehouse/list/index.vue");
export const createWarehouse: ViewComponent = () =>
  import("@/views/warehouse/create/index.vue");
export const updateWarehouse: ViewComponent = () =>
  import("@/views/warehouse/update/index.vue");
export const detailWarehouse: ViewComponent = () =>
  import("@/views/warehouse/detail/index.vue");
